(function () {
  if (window.__v2Motion) { return; }
  window.__v2Motion = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(scope) {
    var els = (scope || document).querySelectorAll(
      '[data-v2-reveal]:not(.is-inview), [data-v2-reveal-image]:not(.is-inview)'
    );
    els.forEach(function (el) { el.classList.add('is-inview'); });
  }

  function init(scope) {
    var root = scope || document;
    var els = root.querySelectorAll(
      '[data-v2-reveal]:not(.is-inview), [data-v2-reveal-image]:not(.is-inview)'
    );
    if (!els.length) { return; }
    if (reduce || !('IntersectionObserver' in window)) { revealAll(root); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        var d = e.target.getAttribute('data-v2-reveal-delay');
        if (d) { e.target.style.transitionDelay = d + 'ms'; }
        e.target.classList.add('is-inview');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) {

      var r = el.getBoundingClientRect();
      if (r.top < (window.innerHeight || 0) * 0.92 && r.bottom > 0) {
        var d = el.getAttribute('data-v2-reveal-delay');
        if (d) { el.style.transitionDelay = d + 'ms'; }
        requestAnimationFrame(function () { el.classList.add('is-inview'); });
      } else {
        io.observe(el);
      }
    });
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', function () { init(); }); }

  document.addEventListener('shopify:section:load', function (e) {
    setTimeout(function () { init(e.target || document); }, 60);
  });
})();
